import React from "react";

import ProductPage from "../../../components/ProductPage";

import hero from "../../../img/doplnky-product.jpg";
import glassesCaseIcon from "../../../img/glasses-case.png";
import bleachingIcon from "../../../img/bleaching.svg";
import roztokIcon from "../../../img/roztok.svg";
import reviewImage from "../../../img/person-for-products3.jpg";

const Doplnky = () => (
  <ProductPage
    title="Doplňky"
    centeredHeading
    description="Doplňky, které Optika Volyně nabízí svým zákazníkům"
    keywords="Optika, Optometrie, Volyně, Brýle, Pouzdra, Roztoky na čočky, Čistící prostředky"
    hero={hero}
    heroAlt="foto optických doplňků"
    boxes={[
      {
        icon: glassesCaseIcon,
        iconAlt: "ikona pouzdra na bryle",
        heading: "Pouzdra",
        text: "V nabídce máme velké množství různých pouzder na brýle. Vyberte si elegantní, módní pouzdro a nebo se odvažte a kupte dětem některé s bláznivým motivem. Ať si vyberete jakékoliv, můžete si být jistí, že vaše brýle jsou v bezpečí.",
      },
      {
        icon: bleachingIcon,
        iconAlt: "ikona cisticiho prostredku",
        heading: "Čisticí prostředky",
        text: "Hadříky, čisticí prostředky na brýle a další. Pečujte o své brýle za pomoci těch nejkvalitnějších produktů a ujistěte se, že na svět budete koukat bez jediné šmouhy.",
      },
      {
        icon: roztokIcon,
        iconAlt: "ikona roztoku",
        heading: "Roztoky na čočky",
        text: "Najdete u nás i kvalitní roztoky pro péči o vaše kontaktní čočky a to za přívětivé ceny. Roztoky zvlhčují, dezinfikují a některé z nich fungují i jako oční kapky. Přesvědčte se sami, že díky nim může být nošení čoček ještě pohodlnější.",
      },
    ]}
    review={{
      text: "Péče o zrak může být občas trochu finančně náročná a proto jsem rád, že v optice Volyně mi vždy poradí, co je pro mě nejlepší a mám možnost to nakoupit za super cenu. Díky roztoku na čočky občas úplně zapomínám, že je vlastně nosím a když je na sobě doopravdy nemám, na vše se dívám přes skvěle vyčištěné brýle.",
      image: reviewImage,
      imageAlt: "referent Ladislav",
      name: "Ladislav",
    }}
  />
);

export default Doplnky;
